import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { contractSalesPost } from '@/services/api/requests/contact';
import { TCustomAxiosError } from '@/services/api';

const useContactSales = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async (contractInfo: { contractId: string; subject: string; message: string }) => {
      if (!contractInfo.contractId) throw Error('No Contract ID');

      const response = await contractSalesPost(contractInfo.contractId, contractInfo.message, contractInfo.subject);

      return response;
    },
    onSuccess: () => {
      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Sales contacted successfully!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Error while contacting sales',
      }, error);
    },
  });

  return { isPending, mutate };
};

export default useContactSales;
